export function useFooterData(config) {
  const brand = config?.brand || {}
  const contact = config?.contact || {}
  const nav = Array.isArray(config?.footerNav) ? config.footerNav : []
  const social = Array.isArray(config?.social) ? config.social : []
  const year = new Date().getFullYear()
  const poweredBy = config?.poweredBy || 'Workit'
  const description = (brand.description && String(brand.description).trim()) || ''

  return { brand, contact, nav, social, year, poweredBy, description }
}
